import styled from 'styled-components';

export const NotiContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
`;

export const NotiHeader = styled.div`
  padding: 20px;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  color: #333;
  background: white;
  border-bottom: 1px solid #E5E5E5;
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  max-width: 480px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
`;

export const NotiBack = styled.button`
  position: absolute;
  left: 20px;
  border: none;
  background: none;
  padding: 8px;
  cursor: pointer;
  color: #333;
  font-size: 20px;
  display: flex;
  align-items: center;
`;

export const NotiTitle = styled.div`
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
`;

export const NotiSortDiv = styled.div`
  z-index: 1;
  margin-top: 80px;
  border-bottom: 1.5px solid #d4d4d4;
`;

export const NotiSort = styled.select`
  display: flex;
  padding: 7px 15px 7px 5px;
  margin: 10px 13px;
  background-color: #f1f1f1;
  border: none;
  border-radius: 8px;
  font-size: 13px;

  &:focus {
    outline: none;
  }
`;

export const NotiBoard = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  max-height: calc(100vh - 110px);
`;
